import React, { useState } from "react";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import * as Yup from "yup";
import "./ContactUs.css";
import { Helmet } from "react-helmet";
import usa from "../../assets/images/usa.png";
import bengaluru from "../../assets/images/bengaluru.png";
import mail from "../../assets/images/mail.png";
import DOMPurify from "dompurify";
import phone from "../../assets/images/phone.png";
import { motion } from "framer-motion";

const ContactUs = () => {
  const [isOthers, setIsOthers] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      jobTitle: "",
      companyName: "",
      inquiryType: "",
      // others: "",
      countryName: "",
      message: "",
      privacyPolicy: false,
    },
    validationSchema: Yup.object({
      firstName: Yup.string()
        .matches(/^[a-zA-Z\s]+$/, "Invalid name (letters & spaces only)")
        .required("First Name is required"),
      lastName: Yup.string()
        .matches(/^[a-zA-Z\s]+$/, "Invalid name (letters & spaces only)")
        .required("Last Name is required"),
      email: Yup.string()
        .email("Invalid email address")
        .notOneOf(["ericjonesmyemail@gmail.com"], "This email is not allowed")
        .required("Email is required"),
      phone: Yup.string().matches(
        /^[0-9]{10}$/,
        "Phone number must be 10 digits"
      ),
      jobTitle: Yup.string()
        .matches(/^[a-zA-Z\s]+$/, "Invalid Job Title (letters and spaces only)")
        .required("Job Title is required"),
      companyName: Yup.string()
        .matches(
          /^[a-zA-Z\s]+$/,
          "Invalid Company Name (letters and spaces only)"
        )
        .required("Company Name is required"),
      inquiryType: Yup.string().required("Inquiry Type is required"),
      countryName: Yup.string()
        .matches(/^[a-zA-Z\s]+$/, "Invalid location (letters and spaces only)")
        .required("Country Name is required"),
      message: Yup.string().matches(
        /^[a-zA-Z0-9\s]+$/,
        "Subject can only contain letters, numbers, and spaces"
      ),
      privacyPolicy: Yup.boolean().oneOf(
        [true],
        "Please accept the privacy policy"
      ),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const apiUrl = `${process.env.REACT_APP_NEWSLETTER_API_URL}/contact-us`;

        // 1. Get user's IP address
        const ipResponse = await fetch("https://api64.ipify.org?format=json");
        const ipData = await ipResponse.json();
        const userIp = ipData.ip;

        // 2. Execute reCAPTCHA
        if (!window.grecaptcha) {
          console.error("reCAPTCHA not loaded");
          return;
        }

        const recaptchaToken = await window.grecaptcha.execute(
          "6LdBbjYrAAAAAAIqGFu0XNk0qdXAm6C8jVR7svrW",
          { action: "submit_form" }
        );

        // 3. Sanitize values
        const sanitizedValues = {
          firstName: DOMPurify.sanitize(values.firstName),
          lastName: DOMPurify.sanitize(values.lastName),
          email: DOMPurify.sanitize(values.email),
          phone: DOMPurify.sanitize(values.phone),
          subject: DOMPurify.sanitize(values.subject),
          jobTitle: DOMPurify.sanitize(values.jobTitle),
          companyName: DOMPurify.sanitize(values.companyName),
          inquiryType: DOMPurify.sanitize(values.inquiryType),
          message: DOMPurify.sanitize(values.message),
        };

        const formData = {
          // to: "karthikeyan.s@idexcel.com",
          ...sanitizedValues,
          countryName: values.countryName,
          ip: userIp,
        };

        // 4. Send form data
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
          body: JSON.stringify(formData),
        });

        if (response.ok) {
          resetForm();
          navigate("/thank-you");
        } else {
          const errorText = await response.text();
          resetForm();
          console.error("Server responded with error:", errorText);
        }
      } catch (error) {
        resetForm();
        console.error("Error sending email", error);
      }
    },
  });
  console.log(formik.isSubmitting);
  const handleInquiryTypeChange = (e) => {
    const { value } = e.target;
    formik.setFieldValue("inquiryType", value);
    setIsOthers(value === "others");
  };

  return (
    <div className="ContactUs-page">
      <Helmet>
        <title>Contact Us | Idexcel</title>
        <meta
          content="idexcel contact, idexcel address, idexcel usa, idexcel india, idexcel location"
          name="keywords"
        />
        <meta
          content="Contact Us - Phone Number: 1-703-230-2600 | Email: inquiry@idexcel.com. You should receive a response within 24 hours."
          name="description"
        />
      </Helmet>
      <motion.div
        className="Productright"
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <Container fluid className="contact-banner-section">
          <section className="contact-banner-section"></section>
        </Container>
      </motion.div>

      <Container className="my-3 px-xl-5">
        <section className="ContactUs">
          <h2 className="text-center mb-4 section-title">
            <span className="textgrad"> Contact </span>Us
          </h2>
          <p className="mb-5">
            Thank you for your interest in idexcel’s services. Please provide
            the following information about your business needs to help us serve
            you better. This information will enable us to route your request to
            the appropriate person. You should receive a response within 24
            hours.
          </p>
          <h2 className="fw-semibold text-center">Get In Touch</h2>
          <div>
            <section className="mt-2 submit-resume p-0">
              <Row className="m-0 p-0  mt-3">
                <Container className="px-lg-0 pb-5">
                  <Form
                    className="d-flex flex-wrap justify-content-start"
                    onSubmit={formik.handleSubmit}
                  >
                    <Col className="input-tag  my-2">
                      <input
                        className="w-100 bg-white py-2 px-3 border"
                        type="text"
                        placeholder="First Name*"
                        {...formik.getFieldProps("firstName")}
                      />
                      {formik.touched.firstName && formik.errors.firstName && (
                        <div className="text-danger">
                          {formik.errors.firstName}
                        </div>
                      )}
                    </Col>
                    <Col className=" input-tag  my-2 ">
                      <input
                        className="w-100 bg-white py-2 px-3 border"
                        type="text"
                        placeholder="Last Name*"
                        {...formik.getFieldProps("lastName")}
                      />
                      {formik.touched.lastName && formik.errors.lastName && (
                        <div className="text-danger">
                          {formik.errors.lastName}
                        </div>
                      )}
                    </Col>
                    <Col className="input-tag  my-2 ">
                      <input
                        className="w-100 bg-white py-2 px-3 border"
                        type="text"
                        placeholder="Email*"
                        {...formik.getFieldProps("email")}
                      />
                      {formik.touched.email && formik.errors.email && (
                        <div className="text-danger">{formik.errors.email}</div>
                      )}
                    </Col>
                    <Col className="  input-tag my-2 ">
                      <input
                        className="w-100 bg-white py-2 px-3 border"
                        type="text"
                        placeholder="Phone Number*"
                        {...formik.getFieldProps("phone")}
                      />
                      {formik.touched.phone && formik.errors.phone && (
                        <div className="text-danger">{formik.errors.phone}</div>
                      )}
                    </Col>
                    <Col className=" input-tag  my-2 ">
                      <input
                        className="w-100 bg-white py-2 px-3 border"
                        type="text"
                        placeholder="Job Title*"
                        {...formik.getFieldProps("jobTitle")}
                      />
                      {formik.touched.jobTitle && formik.errors.jobTitle && (
                        <div className="text-danger">
                          {formik.errors.jobTitle}
                        </div>
                      )}
                    </Col>
                    <Col className="input-tag  my-2 ">
                      <input
                        className="w-100 bg-white py-2 px-3 border"
                        type="text"
                        placeholder="Company Name*"
                        {...formik.getFieldProps("companyName")}
                      />
                      {formik.touched.companyName &&
                        formik.errors.companyName && (
                          <div className="text-danger">
                            {formik.errors.companyName}
                          </div>
                        )}
                    </Col>
                    <Col className=" input-tag  my-2 ">
                      <select
                        className="w-100 bg-white  text-secondary py-2 px-3 border"
                        {...formik.getFieldProps("inquiryType")}
                        onChange={handleInquiryTypeChange}
                      >
                        <option value="" label="Select Inquiry Type" disabled />
                        <option value="salesInquiry" label="Sales Inquiry" />
                        <option
                          value="productInformation"
                          label="Product Information"
                        />
                        <option
                          value="partnershipInquiry"
                          label=" Partnership Inquriy"
                        />
                        <option
                          value="supportRequest"
                          label="Support Request"
                        />
                        <option
                          value="HumanRelations"
                          label="Human Relations"
                        />
                        <option
                          value="publicRelations"
                          label="Public Relations"
                        />
                        <option
                          value="generalInquiry"
                          label="General Inquiry"
                        />
                        {/* <option value="others" label="Others" /> */}
                      </select>
                      {formik.touched.inquiryType &&
                        formik.errors.inquiryType && (
                          <div className="text-danger">
                            {formik.errors.inquiryType}
                          </div>
                        )}
                    </Col>
                    {/* {isOthers && (
                      <Col className=" input-tag my-2 ">
                        <input
                          className="w-100 bg-white py-2 px-3 border"
                          type="text"
                          placeholder="If Others Please Specify"
                          {...formik.getFieldProps("others")}
                        />
                        {formik.touched.others && formik.errors.others && (
                          <div className="text-danger">
                            {formik.errors.others}
                          </div>
                        )}
                      </Col>
                    )} */}
                    <Col className="input-tag  my-2 ">
                      <input
                        className="w-100 bg-white py-2 px-3 border"
                        type="text"
                        placeholder="Country Name*"
                        {...formik.getFieldProps("countryName")}
                      />
                      {formik.touched.countryName &&
                        formik.errors.countryName && (
                          <div className="text-danger">
                            {formik.errors.countryName}
                          </div>
                        )}
                    </Col>
                    <Col xs={12} className="my-2">
                      <textarea
                        className="w-100 bg-white py-2 px-3 border"
                        placeholder="Message"
                        {...formik.getFieldProps("message")}
                      />
                    </Col>

                    <Col xs={12} className="my-2">
                      <input
                        type="checkbox"
                        id="privacyPolicy"
                        {...formik.getFieldProps("privacyPolicy")}
                      />
                      <label htmlFor="privacyPolicy" className="ms-2">
                        I confirm that I have read and agree to Idexcel's
                        <a
                          href="/privacy-policy"
                          rel="noopener noreferrer"
                          className="px-1"
                        >
                          Privacy Policy
                        </a>
                        and consent to the sharing of my information.
                      </label>
                      {formik.touched.privacyPolicy &&
                        formik.errors.privacyPolicy && (
                          <div className="text-danger">
                            {formik.errors.privacyPolicy}
                          </div>
                        )}
                    </Col>

                    <Col xs={12} className="text-center my-2">
                      <Button
                        type="submit"
                        className="button career-submit mt-3"
                        disabled={formik.isSubmitting}
                      >
                        {formik.isSubmitting
                          ? "Sending Message..."
                          : "Send Message"}
                      </Button>
                    </Col>
                  </Form>
                </Container>
              </Row>
            </section>
          </div>
        </section>
      </Container>
      <section
        className="contact-info pb-5"
        style={{ background: "whitesmoke" }}
      >
        <Container className="">
          <Col lg={12}>
            <h2 className="text-center mb-4 section-title">
              Our Office <span className="textgrad"> Locations </span>
            </h2>
          </Col>
          <Row className="justify-content-center">
            <Col lg={5} md={6} sm={12} className="mb-4">
              <Card className="h-100">
                <Card.Img variant="top" src={usa} alt="USA Office" />
                <Card.Body>
                  <Card.Title className="fw-semibold">
                    Corporate Headquarters - USA
                  </Card.Title>
                  <Card.Text>
                    Suite #10, 459 Herndon Pkwy, Herndon, VA 20170
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={5} md={6} sm={12} className="mb-4">
              <Card className="h-100">
                <Card.Img
                  variant="top"
                  src={bengaluru}
                  alt="Bengaluru Office"
                />
                <Card.Body>
                  <Card.Title className="fw-semibold">
                    Corporate Headquarters - India
                  </Card.Title>
                  <Card.Text>
                    Crystal Plaza 9,10,11 Bhuvanappa Layout, Hosur Rd,
                    Bengaluru, Karnataka 560029
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="justify-content-evenly align-items-center mt-4 contact-info-data">
            <Col
              lg={4}
              md={4}
              sm={6}
              className="text-center justify-content-center align-items-center d-flex mb-3"
            >
              <img
                src={mail}
                alt="Mail Icon"
                className="mb-2 mx-2"
                style={{ width: "50px" }}
              />
              <h5 className="m-0 mx-2">Write to Us</h5>
              <a
                href="mailto:info@idexcel.com"
                className="text-decoration-none mx-1"
              >
                info@idexcel.com
              </a>
            </Col>
            <Col
              lg={4}
              md={4}
              sm={6}
              className="text-center justify-content-center align-items-center d-flex mb-3"
            >
              <img
                src={phone}
                alt="Phone Icon"
                className="mb-2 mx-2"
                style={{ width: "50px" }}
              />
              <h5 className="m-0 mx-2">Call Us</h5>
              <a
                href="tel:1-703-230-2600"
                className="text-decoration-none mx-1"
              >
                1-703-230-2600
              </a>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default ContactUs;
